import { Mentionable } from "../../../../../common/sesh_types";
import { DashboardUtils } from "../../dashboard_utils";
import { SearchableDropdown } from "../searchable_dropdown";
import { useRoles } from "./hooks/use_roles";

export function RolesSearchDropdown(props: {
	selected_ids: string[];
	disabled?: boolean;
	should_disable_managed_roles?: boolean;
	should_disable_here?: boolean;
	should_disable_everyone?: boolean;
	handleChange: (event: string[]) => void;
}) {
	const roles = useRoles();

	const loading = !Boolean(roles);
	if (loading) {
		return DashboardUtils.RenderLoadingSelect();
	}

	let filtered_roles = props.should_disable_managed_roles
		? roles.filter((val) => !val.is_managed_role)
		: roles;

	if (props.should_disable_here) {
		filtered_roles = filtered_roles.filter((val) => val.id !== "@here");
	}

	if (props.should_disable_everyone) {
		filtered_roles = filtered_roles.filter((val) => val.id !== "@everyone");
	}

	const selected_mentions = props.selected_ids
		.map((id) => filtered_roles.find((val) => val.id === id))
		.filter((val) => val);

	return (
		<SearchableDropdown
			handleChange={(roles) =>
				props.handleChange(roles.map((val) => val.id))
			}
			options={filtered_roles}
			initial_mentions={selected_mentions}
			ignore_invalid_permissions={false}
			disabled={props.disabled}
			loading={!Boolean(roles)}
			placeholder="Select roles..."
		/>
	);
}
